<template>
  <div class="pdf-paginator">
    <template v-if="pageCount">
        <div class="row">
          <div class="flex pa-1 xs6">
            
           <v-text-field
            v-model="page"
            class="mt-0"
            @input="input"
            min="1"
            :max="pageCount"
            hide-details
            single-line
            type="number"
          ></v-text-field></div><div class="flex pa-2 xs6"></div>
       </div>
    </template>
    <input v-else type="number" />
  </div>
</template>

<script>
export default {
  name: 'PDFPaginator',
  page: 1,
  props: {
    value: Number,
    pageCount: Number,
  },

  methods: {
    input(event) {
      this.$emit('input', parseInt(this.page, 10));
    },
  },

  watch: {
    pageCount() {
      this.$emit('input', 1);
      this.page = 1;
    },
  }
}
</script>

<style>
.pdf-paginator {
  color: black;
  font-weight: bold;
}
.pdf-paginator input {
  width: 3em;
  padding: 0.3em;
}
</style>
